import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface RedirectToLoginProps {
  loginPath?: string,
}

/**
 * Redirect an unauthenticated visitor to the login page while keeping track of
 * the page they originally wanted, passed along as a `redirect` query param so
 * they can be sent back there once logged in.
 */
const RedirectToLogin = ({ loginPath = '/login' }: RedirectToLoginProps) => {
  const { pathname, search, hash } = useLocation();
  const target = `${pathname}${search}${hash}`;
  const skip = target === '/' || pathname.startsWith('/login') || pathname.startsWith('/logout');
  const to = skip ? loginPath : `${loginPath}?redirect=${encodeURIComponent(target)}`;
  return <Navigate to={to} replace />;
};

export default RedirectToLogin;
